import {createStore, applyMiddleware} from 'redux'
import rootReducer from '../reducers'
import thunk from 'redux-thunk'
import {composeWithDevTools} from 'redux-devtools-extension'
import storage from 'redux-persist/lib/storage'
import {persistStore, persistReducer} from 'redux-persist'

const persistConfig = {
  key: 'root',
  debug: true,
  storage,
  whitelist: [
    'catalogos', 
    'userLogin', 
    'creditoFiscal', 
    'facturacion', 
    'notaRemision',
    'notaCredito',
    'notaDebito',
    'notaDebitoExterno',
    'sujetoExcluido',
    'historial',
    'facturaExportacion',
    'comprobanteRetencion',
    'documentos',
    'formaPago',
    'comprobanteLiquidacion',
    'documentoLiquidadcion',
    'notaCreditoExterno',
    'libros',
  ],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = createStore(persistedReducer, {}, composeWithDevTools(applyMiddleware(thunk)))
export const persistor = persistStore(store)
